import useLazySelector, { isCustomer, useLazyLoader } from "common/redux/useLazySelector";
import { Offering } from "./offering";
import { loadOfferings } from "./offerings.actions";
import IsLoaded from "common/isLoaded";

const defaultVal: Offering[] = [];
export default function useOfferings(alwaysRetrieve?: boolean): Offering[] {
    const shouldRetrieve = alwaysRetrieve ? () => true : isCustomer;

    return useLazySelector(store => store.offerings, dispatch => loadOfferings()(dispatch), shouldRetrieve, defaultVal);
}

export function useOfferingsLoader(alwaysRetrieve?: boolean): IsLoaded<Offering[]> {
    const shouldRetrieve = alwaysRetrieve ? () => true : isCustomer;

    return useLazyLoader(m => m.offerings, dispatch => loadOfferings()(dispatch), shouldRetrieve, defaultVal);
}